import React from 'react';
import { concatStyles } from 'utils';
var TITLE_STYLES = 'font-body text-body text-sm font-normal mb-0';
export var Title = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style;
    return (React.createElement("h3", { className: concatStyles([TITLE_STYLES, className]), style: style }, children));
};
Title.displayName = 'Card.Title';
